export { de } from "./de";
export { en } from "./en";
export { es } from "./es";
export { fr } from "./fr";
export { hi } from "./hi";
export { it } from "./it";
export { nl } from "./nl";
export { pt } from "./pt";
export { ro } from "./ro";
export { ru } from "./ru";
export { tr } from "./tr";
export { zhTW } from "./zh-TW";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/uppload/dist/i18n/index.js
// module id = qmLu
// module chunks = 1